export const OptimizersPageSubjects = {
    Page: 'optimizers-page',
    Table: 'optimizers-table',
    CreateOptimizerButton: 'optimizers-create-optimizer-button',
    TableRecord: 'optimizers-table-record',
};
//# sourceMappingURL=optimizers.enum.js.map